<template>
    <div class="-mx-6 px-6 pt-4 border-t">
        <BaseSelect
            :model-value="authStore.userData?.season_id"
            :label="$t('seasons.season')"
            name="current_season_select"
            identifier="id"
            display-key="name"
            open-options-top
            additional-display-key="sport_name"
            spa-route="spa.basicData.seasonSelect.index"
            spa-prefetch
            @update:model-value="setCurrentSeason" />
    </div>
</template>

<script setup lang="ts">
import {useAuthStore} from "~/store/auth"

const authStore = useAuthStore()

async function setCurrentSeason(value: number) {
    if (authStore.userData && authStore.userData.season_id !== value) {
        authStore.userData.season_id = value

        $lara.put(useNuxtApp().$apiRoute("spa.userCurrentSeason.update"), {
            body: {
                current_season_id: value
            }
        }).then(() => {
            authStore.getAuthData()

            // reload the app to reload page data
            reloadNuxtApp({force: true})
        }).catch(error => {
            const notification = useNotification()
            const app = useNuxtApp()
            if (error && error.response && error.response.status === 422) {
                notification.error(app.$i18n.t('invalidRequestData'))
            } else if (error && error.response && error.response.status === 404) {
                notification.error(app.$i18n.t('modelDoesNotExist'))
            }
        })
    }
}
</script>